import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Funcao {
  id: number;
  nome: string;
}

@Injectable({
  providedIn: 'root'
})
export class FuncaoService {
  //private apiUrl = 'https://localhost:7103/api/Funcao'; 
  //getFuncoes(): Observable<Funcao[]> {
    //return this.http.get<Funcao[]>(this.apiUrl);
  //}

  private baseUrl = environment.apiUrlExbeOn;
  private endpoint = '/Funcao';
  constructor(private http: HttpClient) { }

  getFuncoes(): Observable<Funcao[]> {
    return this.http.get<Funcao[]>(`${this.baseUrl}${this.endpoint}`);
  }
  
}